// SLIDER SIEAMA
const prev = document.querySelector(".download_item_slider_prev");
const next = document.querySelector(".download_item_slider_next");
if (prev && next) {
  prev.addEventListener("click", () => mySiema.prev());
  next.addEventListener("click", () => mySiema.next());
  let mySiema = new Siema({
    loop: true,
  });
}

// END SLIDER SIEAMA
